const pages = {
  liveliness: {
    ID: "liveliness",
    route: "/liveliness/:id",
  },
};

export default pages;
